import * as _ from 'lodash';
import baseRequest from './baseRequest';

const SHORT_FORM_SUBMIT_URL = '/api/public/short-form-borrowers';

export async function shortFormSubmit(values, loanType: LoanType) {
  const modelProperties: { [key: string]: any } = _.pick(
    values,
    'annualIncome',
    'cashDownPayment',
    'email',
    'employmentStartDate',
    'employmentType',
    'estimatedCreditScore',
    'firstName',
    'homePhone',
    'lastName',
    'loanPurpose',
    'propertyCounty.countyName',
    'propertyCounty.stateCode',
    'propertySearchType',
    'propertyType',
    'propertyUsageType',
    'purchasePrice',
  );

  modelProperties.econsentGiven = values.acceptTermsAndEconsentGiven || false;

  return await baseRequest.post(SHORT_FORM_SUBMIT_URL, {
    acceptTerms: values.acceptTermsAndEconsentGiven || false,
    loanType,
    modelProperties,
  });
}
